import { memo } from 'react';
import { Split } from 'lucide-react';
import type { NodeProps } from '@xyflow/react';
import type { ComposerNodeData } from '../../../types/composer';
import { ComposerNodeCard } from './ComposerNodeCard';

export const ParallelNode = memo((props: NodeProps) => (
  <ComposerNodeCard
    {...props}
    data={props.data as ComposerNodeData}
    typeName="parallel"
    glyph={<Split size={14} strokeWidth={2.2} />}
  />
));

ParallelNode.displayName = 'ParallelNode';
